import {Component, Input, SimpleChanges} from '@angular/core';
import {ConfirmationService} from "primeng/api";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";
import {
    CmContractObjectViewTypeUiEnum
} from "../../../../page/consultant-page/overview/cm-contract-page/data/cm-contract-object-view-type-ui.enum";
import {ObjectBaseComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base.component";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {ObserverService} from "../../../../../../core/shared/object/service/observer.service";
import {MvsMessageService} from "../../../../../../core/shared/service/message/mvs-message.service";
import {MvsObjectNavigationService} from "../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationProviderGeneric
} from "../../../../../../core/shared/navigation/impl/mvs-object-navigation-provider-generic";
import {ContractDto} from "../../../../model/dto/entity/contract.dto";

@Component({
    selector: 'mvs-cm-contract-consultant',
    templateUrl: './cm-contract-consultant.component.html',
    styleUrls: ['./cm-contract-consultant.component.scss'],
    standalone: false
})
export class CmContractConsultantComponent
  extends ObjectBaseComponent {

  @Input() override transientDto: ContractDto;
  @Input() viewType: CmContractObjectViewTypeUiEnum = CmContractObjectViewTypeUiEnum.standard;

  override dto: ContractDto;
  activeTabIndex: number = 0;
  navObjectIdParameterObserver: Subscription;

  constructor(
    protected override coreService: MvsCoreService,
    protected override confirmationService: ConfirmationService,
    protected override observerService: ObserverService,
    protected override messageService: MvsMessageService,
    protected navigationService: MvsObjectNavigationService,
    protected route: ActivatedRoute) {

    super(coreService, messageService, confirmationService, observerService);

  }


  /**
   * Object Changed
   */
  override onObjectChanged() {
    super.onObjectChanged();

    // refresh the widgets
    this.refreshWidgets();

  }

  initComponent() {
    this.navigationService.setNavigationProvider(new MvsObjectNavigationProviderGeneric());

    super.initComponent();


  }



  /**
   * Initialize the widgets.
   */
  refreshWidgets() {

    // make sure that the widget is loaded
    if (!this.isObjectLoaded()) {
      return;
    }
  }

  override ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (!this.initialized) {
      return;
    }

    if (changes["viewType"]) {
      this.refreshObject(false);
    }

    if (changes["transientDto"]) {
      this.dto = null;
      this.refreshObject(false);
    }

  }
}
